import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, Injectable, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';
import { Observable, of, Subscription } from 'rxjs';

declare var $: any; // declaring jquery in this way solved the problem
declare var KTUtil;
declare var HOST_URL;

import { Directive, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';

export type SortColumn = keyof any | '';
export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = { 'asc': 'desc', 'desc': '', '': 'asc' };

const compare = (v1: string | number, v2: string | number) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

export interface SortEvent {
	column: SortColumn;
	direction: SortDirection;
}

@Directive({
	selector: 'th[sortable]',
	host: {
		'[class.asc]': 'direction === "asc"',
		'[class.desc]': 'direction === "desc"',
		'(click)': 'rotate()'
	}
})
export class NgbdSortableHeader {

	@Input() sortable: SortColumn = '';
	@Input() direction: SortDirection = '';
	@Output() sort = new EventEmitter<SortEvent>();

	rotate() {
		this.direction = rotate[this.direction];
		this.sort.emit({ column: this.sortable, direction: this.direction });
	}
}

export interface Reports {
	title: string;
	APIUrl: string;
	datafilter?: any;
	collection: string;
	type: string;
	series: any;
	field: any;
	data: any;
	filter: any;
	xaxis?: any;
	stacked?: boolean;
	isfilter?: boolean;
	zoom?: boolean;
	size?: number;
};

@Injectable()
export class ReportsService {
	private appmod: string;

	constructor(protected http: HttpClient) {}

	public Report(url: string, type?: string, filter?: any): Observable<any> {
		this.appmod = url;
		//console.log(this.appmod);
		//console.log(type);
		console.log(filter);
		if (filter == undefined) {
			if (type != undefined)
				return this.http.get<any>(this.appmod, { headers: { "Content-Type": "application/json" }, params: { type } });
			else
				return this.http.get<any>(this.appmod, { headers: { "Content-Type": "application/json" }, params: { type: "main" } });
		}
		else {
			if (type != undefined)
				return this.http.get<any>(this.appmod, { headers: { "Content-Type": "application/json" }, params: { type, filter: JSON.stringify(filter) } });
			else
				return this.http.get<any>(this.appmod, { headers: { "Content-Type": "application/json" }, params: { type: "main", filter: JSON.stringify(filter) } });
		}
	}
}

@Component({
	selector: 'Report',
	templateUrl: './report.component.html',
	styleUrls: ['./report.component.css']
})

export class ReportComponent implements OnInit, AfterViewInit, OnDestroy {
	@Input() title:string;
	@Input() APIUrl: string;
	@Input() datafilter?: string;
	@Input() collection: string;
	@Input() type: string;
	@Input() series: any;
	@Input() field: any;
	@Input() data: any;
	@Input() filter: any;
	@Input() xaxis: any;
	@Input() stacked?: boolean = false;
	@Input() isfilter: boolean;
	@Input() zoom?: boolean = false;
	@Input() size?: number = 200;
	private sub: Subscription;
	public tablestatus: boolean = false;
	public reportstatus: boolean = false;
	public reportdata: any[];
	collectionSize: any;
	x: any;

	@ViewChild("chart",  {static: false}) chart: ChartComponent;
	constructor(private report: ReportsService) { }

	page = 1;
	public pageSize = 4;
	@ViewChildren(NgbdSortableHeader) headers1: QueryList<NgbdSortableHeader>;

	onSort({ column, direction }: SortEvent) {
		// resetting other headers
		this.headers1.forEach(header => {
			if (header.sortable !== column) {
				header.direction = '';
			}
		});

		// sorting countries
		if (direction === '' || column === '') {
			this.x = this.x;
		} else {
			this.x = [...this.x].sort((a, b) => {
				const res = compare(a[column], b[column]);
				return direction === 'asc' ? res : -res;
			});
		}
	}

	OnDataChange(event: any) {
		console.log(event.target.value);
		Object.entries(this.filter).forEach(ele => {
			this.filter[ele[0]] = event.target.value;
		});
		this.reportstatus = false;
		if (this.type == "bar" || this.type == "area" || this.type == "line") {
			this.sub = this.report.Report(this.APIUrl + "mixed", this.collection, { zoom: this.zoom, stacked: this.stacked, gtype: this.type, series: this.series, fields: this.field, data: this.data, filter: this.filter, xaxis: this.xaxis, size: this.size }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				this.reportstatus = true;
			});
		}

		if (this.type == "donut" || this.type == "pie" || this.type == "radialBar") {
			this.sub = this.report.Report(this.APIUrl + "circular", this.collection, { zoom: this.zoom, stacked: this.stacked, gtype: this.type, series: this.series, fields: this.field, data: this.data, filter: this.filter, size: this.size }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				this.reportstatus = true;
			});
		}

		if (this.type == "table") {
			this.sub = this.report.Report(this.APIUrl + "data", this.collection, { series: this.series, fields: this.field, data: this.data, filter: this.filter }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				this.collectionSize = this.reportdata.length;
				this.x = this.reportdata
					.map((x, i) => ({ id: i + 1, ...x })).slice((this.page - 1));



				this.tablestatus = true;
			});
		}

		if (this.type == "notification") {
			this.sub = this.report.Report(this.APIUrl + "data", this.collection, { series: this.series, fields: this.field, data: this.data, filter: this.filter }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				this.tablestatus = true;
			});
		}

		if (this.type == "conversation") {
			this.sub = this.report.Report(this.APIUrl + "data", this.collection, { series: this.series, fields: this.field, data: this.data, filter: this.filter }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				this.tablestatus = true;
			});
		}

	}

	ngOnInit(){
		console.log(this.title);
		console.log(this.APIUrl);
	}

	ngAfterViewInit() {

		if (this.type == "bar" || this.type == "area" || this.type == "line") {
			this.sub = this.report.Report(this.APIUrl + "mixed", this.collection, { zoom: this.zoom, stacked: this.stacked, gtype: this.type, series: this.series, fields: this.field, data: this.data, filter: this.filter, xaxis: this.xaxis, size: this.size }).subscribe(res => {
				//console.log(res);
				this.reportdata = res;
				this.reportstatus = true;
			});
		}

		if (this.type == "donut" || this.type == "pie" || this.type == "radialBar") {
			this.sub = this.report.Report(this.APIUrl + "circular", this.collection, { zoom: this.zoom, stacked: this.stacked, gtype: this.type, series: this.series, fields: this.field, data: this.data, filter: this.filter, size: this.size }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				this.reportstatus = true;
			});
		}

		if (this.type == "table") {
			this.sub = this.report.Report(this.APIUrl + "data", this.collection, { series: this.series, fields: this.field, data: this.data, filter: this.filter }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				this.collectionSize = this.reportdata.length;
				this.x = this.reportdata
					.map((x, i) => ({ id: i + 1, ...x })).slice((this.page - 1));

				this.tablestatus = true;
			});
		}

		if (this.type == "notification") {
			this.sub = this.report.Report(this.APIUrl + "data", this.collection, { series: this.series, fields: this.field, data: this.data, filter: this.filter }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				this.tablestatus = true;
			});
		}

		if (this.type == "conversation") {
			this.sub = this.report.Report(this.APIUrl + "data", this.collection, { series: this.series, fields: this.field, data: this.data, filter: this.filter }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				this.tablestatus = true;
			});
		}
	}

	refreshCountries() {
		this.x = this.reportdata
			.map((x, i) => ({ id: i + 1, ...x })).slice((this.page - 1));

	}

	ngOnDestroy() {
		this.sub.unsubscribe();
	}
}